var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeallogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 222,
    viewBox: "0 0 222 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_768_672)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 200,
    height: 200,
    fill: "url(#pattern0_768_672)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_768_672",
    x: 0,
    y: 0,
    width: 222,
    height: 222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_768_672"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.345098 0 0 0 0 0.133333 0 0 0 0 0.870588 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_768_672"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_768_672",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_768_672",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_768_672",
    transform: "scale(0.004)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_768_672",
    width: 250,
    height: 250,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeallogo1);
export default __webpack_public_path__ + "static/media/ideal logo 1.8e7b13d37c3729fbde18fc1009d9a2fe.svg";
export { ForwardRef as ReactComponent };